define.alias("shared/components/shared/ui/social-profile-switcher", "preview-grid/components/shared/ui/social-profile-switcher");